import { Box, makeStyles, Typography } from '@material-ui/core'
import { FC } from 'react'

const Item: FC<{ isAll: boolean; title: string; number: number }> = ({ isAll, title, number }) => {
    const classes = useStyles({ isAll })
    return (
        <Box className={classes.boxItem}>
            <Typography className={classes.typo} variant="h4">
                {number}
            </Typography>
            <Typography className={classes.typo}>{title}</Typography>
            <div className={classes.watermark1}>
                <svg height="100" width="100">
                    <circle cx="50" cy="50" r="30" stroke="#ffffff" stroke-width="1" fill="#ffffff" />
                </svg>
            </div>
            <div className={classes.watermark2}>
                <svg height="100" width="100">
                    <circle cx="50" cy="50" r="40" stroke="#ffffff" stroke-width="1" fill="#ffffff" />
                </svg>
            </div>
        </Box>
    )
}

const useStyles = makeStyles((theme) => ({
    typo: {
        color: '#ffffff',
        width: '120px',
    },
    watermark1: {
        opacity: '0.075',
        color: '#ffffff',
        position: 'absolute',
        top: '0',
        left: '30%',
        [theme.breakpoints.down('xs')]: {
            left: '35%',
        },
    },
    watermark2: {
        opacity: '0.075',
        color: '#ffffff',
        position: 'absolute',
        top: '10%',
        left: '50%',
    },
    boxItem: {
        height: '130px',
        position: 'relative',
        cursor: 'pointer',
        fontWeight: 'bold',
        margin: ' 8px',
        padding: '24px 24px 0px 24px',
        border: '1px solid #bdbdbd',
        borderRadius: '6px',
        background: (props: { isAll: boolean }) => {
            if (props.isAll) {
                return 'linear-gradient(#DB5F8E, #6E3047)'
            } else {
                return 'linear-gradient(#58A4B0, #2C5258)'
            }
        },
    },
}))

export default Item
